import { TFunction } from 'i18next'
import { showNotification } from '../../components/custom_components/Notification/notification'
import { OtherMeetingFinishPreparation } from '../../graphql/meeting/hooks/useOtherMeeting'
import { FullMeetingFragment } from '../../types'

export const processOtherMeeting = async (
  t: TFunction,
  meeting: FullMeetingFragment,
  textAreaValue: string,
  isManager: boolean,
): Promise<void> => {
  try {
    await OtherMeetingFinishPreparation(meeting, textAreaValue, isManager)
  } catch (err) {
    showNotification({
      type: 'error',
      message: t('global.notifications.error.title'),
      description: t('global.notifications.error.description'),
    })
  }
}
